import styled from 'styled-components';

import {maxWidth} from '../common/StyleValue'
import MainImg from '../../assets/main_bg.png'
import HowbgImg from '../../assets/howbg.png'


const Line = styled.span`
  display: block;
  background-color: #787878;
  height: 1px;
  width: 180px;
  margin: ${({mode})=> mode==='center' || mode === undefined ? 'auto' : 0}
`;

const HowtoStyle = styled.div`
  width: ${maxWidth}px;
  margin: 30px auto;
  .head-tit {
    color: #666;
    text-align: center;
    padding: 10px 0 30px;
  }
  .title {
    display: flex;
    margin-top: 20px;
    h2 {
      width: 62%;
      color: #2A2D35;
      font-size: 32px;
      text-align: center;
      background: url(${HowbgImg}) no-repeat;
      background-size: cover;
      border-radius: 15px;
      padding: 50px 0 130px;
      font-weight: 400;
    }
  }
  .how-box {
    display: flex;
    justify-content: flex-end;
    .box-list {
      position: relative;
      margin-top: -90px;
      flex-wrap: wrap;
      display: flex;
      margin-right: -10px;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    .title {
      margin: 30px auto 20px;
      h2 {
        width: 100%;
        font-size: 28px;
      }
    }
    .how-box {
      width: 100%;
      margin: 0 auto;
      display: block;
      >img {
        width: 100%;
        padding: 0 25%;
      }
      .box-list {
        width: 100%;
        .list-item {
          width: 100%;
        }
      }
    }
  }
`;

const IntroStyle = styled.div`
  section {
    @media (min-width: 769px) {
      padding: 0 20px;
    }
    background: url(${MainImg}) no-repeat;
    background-position: 50%;
    background-size: cover;
    padding-bottom: 180px;
    width: 100%;
    position: relative;

    .part {
      width: 1080px;
      margin: 0 auto;
      padding-top: 60px;
      padding-bottom: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .part-left {
        width: 50%;
        color: #fff;
        h1 {
          margin: 40px 0 20px 0;
          font-size: 30px;
          font-weight: 700;
          color: #fff;
          line-height: 42px;
        }
        .desc {
          line-height: 28px;
        }
        p {
          /* text-align: justify; */
          margin-bottom: 0px;
          position: relative;
          font-size: 15px;
          line-height: 22px;
          color: hsla(0,0%,100%,.8);
          &:first-child::before {
            content: '·';
            position: absolute;
            left: -15px;
            color: #fff;
            font-size: 30px;
          }
        }
      }

      >.iimg {
        margin-top: 40px;
        width: 42%;
        img {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    section {
      padding-bottom: 80px;
      .part {
        width: 100%;
        flex-wrap: wrap;
        padding: 0 20px;
        .part-left {
          h1 {
            margin: 40px 0 20px 0;
          }
          width: 100%;
        }
        >.iimg {
          width: 80%;
          flex-basis: 100%;
          padding: 0 25%;
          img {
            width: 100%;
          }
        }
      }
    }
  }
`;

const Gh1 = styled.h1`
  color: #333;
  text-align: center;
  max-width: ${maxWidth}px;
  margin: 80px auto 0;
  /* font-size: 44px !important; */
`

const GuideBoxStyle = styled.div`
  width: ${maxWidth}px;
  background-color: #fff;
  box-shadow: 9px 9px 30px -4px rgba(13, 64, 152, 0.16);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  align-items: center;

  margin: -120px auto 0;
  position: relative;

  .gh1 {

  }

  >.mimg {
    width: 28%;
    padding: 0 5%;
    img {
      width: 100%;
    }
  }
  .desc {
    margin-left: 8%;
    color: #333;
    h1 {
      margin-bottom: 10px;
      color: #2A2D35;
      /* line-height: 60px; */
      font-weight: 400;
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    margin: -50px auto 0;
    align-items: center;
      >img {
        width: 14%;
        padding: 0;
      }
      .desc {
        h1 {
          margin-bottom: 0;
        }
      }
      .mimg {
        display: none;
      }
    }

`;

const ListItemStyle = styled.div`
  box-shadow: 8px 8px 24px -4px rgba(13, 64, 152, 0.16);
  border-radius: 16px;
  width: 31.5%;
  overflow: hidden;
  margin: 0 0 15px 0;
  padding: 20px 20px 50px;
  transition: all .3s;
  position: relative;
  background-color: #fff;
  &:hover {
    box-shadow: 8px 8px 24px -4px rgba(13, 64, 152, 0.26);
  }
  .tag-img {
    margin-bottom: 15px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .title {
    color: #3D6DE5;
    font-weight: 400;
  }
  .desc {
    color: #666666;
    line-height: 24px;
    font-size: 18px;
    list-style: disc;
    margin-left: 20px;
    margin-top: 20px;
    li {
      padding-bottom: 8px;
    }
  }
  .number {
    position: absolute;
    bottom: -15px;
    right: 10px;
    font-size: 89px;
    font-weight: 500;
    color: #bbb;
    opacity: .15;
  }
  @media (max-width: 768px) {
    padding: 20px 20px 30px;
    width: 100%;
    height: auto;
    .tag-img {
      margin-bottom: 0;
    }
    .desc {
      line-height: 24px;
      font-size: 16px;
      margin-top: 0;
      li {
        padding-bottom: 0;
      }
    }
  }
`;  

const StartBoxStyle = styled.div`
  width: ${maxWidth}px;
  margin: auto;
  padding: 50px 0 80px 0;
  color: #333;
  .md-40 {
    margin-bottom: 40px;
  }
  .start-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 6px 6px 19px -3px rgba(13, 64, 152, 0.16);
    border-radius: 13px;
    padding: 10px 40px;

    .contents {
      width: 52%;
      h1 {
        margin-top: 50px;
        color: #2A2D35;
        font-weight: 500;
      }
      .desc {
        margin-top: 20px;
        color: #666666;
        font-size: 22px;
        list-style: disc;
        a {
          text-decoration: none;
        }
      }
    }

    .simg {
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 62%;
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    .start-box {
      display: block;
      width: 100%;
      padding: 10px;
      .contents {
        width: 100%;
        margin-top: 50px;
        h1 {
          margin-top: 30px;
        }
        .desc {
          line-height: 30px;
          font-size: 20px;
          padding: 0 10px;
        }
      }
      .simg {
        width: 100%;
        padding: 0 25%;
        img {
          width: 100%;
        }
      }
    }
  }
`;

const FundStyle = styled.div`
  margin: auto;
  margin-top: 110px;
  width: ${maxWidth}px;
  display: flex;
  justify-content: space-between;
  >div {
    width: 50%;
    h1 {
      color: #2A2D35;
      margin: 50px 0;
    }
    .desc {
      color: #666666;
      font-size: 22px;
    }
  }
  >.fimg {
    margin-top: -70px;
    width: 42%;
    padding-right: 6%;
    img {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    padding: 0 20px;
    margin-top: 60px;
    display:block;
    width: 100%;
    >div {
      width: 100%;
      h1 {
        color: #2A2D35;
        margin: 25px 0;
      }
      .desc {
        font-size: 24px;
      }
    }
    >.fimg {
      width: 100%;
      padding: 0 25%;
      margin-top: 0px;
      img {
        width: 100%;
      }
    }
  }
`;

const StartItemStyle = styled.ul`
  background: #FFFFFF;
  margin-top: 20px;
  line-height: 32px;
  color: #666666;
  font-size: 22px;
  list-style: disc;
  padding: 20px 20px 20px 30px;
  a {
    text-decoration: none;
  }
  .tag-img {
    margin-left: -20px;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    h3 {
      color: #333;
      font-weight: 500;
      margin-left: 15px;
      margin-top: 8px;
    }
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  >li {
    margin-bottom: 12px;
  }
`;

export { 
  Line,
  HowtoStyle,
  GuideBoxStyle,
  IntroStyle,
  ListItemStyle,
  StartBoxStyle,
  FundStyle,
  Gh1,
  StartItemStyle,
}